// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E96R","fullView":"styles_fullView__38u_B"};